// extracted by mini-css-extract-plugin
export default {"container":"EntityModelRef_container__0Ec4z","label":"EntityModelRef_label__agANL","value":"EntityModelRef_value__MRQ0h"};